"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarTable = exports.getTimeRange = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var DateTable_1 = require("./tables/DateTable");
var BaseTable_1 = require("./tables/BaseTable");
var MonthTable_1 = require("./tables/MonthTable");
var FadeTransition_1 = require("../transition/FadeTransition");
var YearTable_1 = require("./tables/YearTable");
var TimeTable_1 = require("../timepicker/TimeTable");
var i18n_1 = require("../i18n");
var RangePickerContext_1 = require("../datepicker/RangePickerContext");
var util_1 = require("../datepicker/util");
/**
 * 获取当前时间选择范围
 */
function getTimeRange(value, range) {
    if (range === void 0) { range = [null, null]; }
    if (!Array.isArray(range) || !value) {
        return undefined;
    }
    var _a = tslib_1.__read(range, 2), min = _a[0], max = _a[1];
    var timeRange = [
        moment_1.default().startOf("day"),
        moment_1.default().endOf("day"),
    ];
    if (moment_1.default.isMoment(min) && util_1.isSame(value, min, "day")) {
        timeRange[0] = min;
    }
    if (moment_1.default.isMoment(max) && util_1.isSame(value, max, "day")) {
        timeRange[1] = max;
    }
    return timeRange;
}
exports.getTimeRange = getTimeRange;
function CalendarTable(_a) {
    var value = _a.value, onChange = _a.onChange, type = _a.type, onTypeChange = _a.onTypeChange, _b = _a.curViewMoment, curViewMoment = _b === void 0 ? moment_1.default() : _b, onCurViewMomentChange = _a.onCurViewMomentChange, range = _a.range, _c = _a.disabledDate, disabledDate = _c === void 0 ? function () { return true; } : _c, _d = _a.disabledMonth, disabledMonth = _d === void 0 ? function () { return true; } : _d, _e = _a.disabledTime, disabledTime = _e === void 0 ? function () { return ({}); } : _e, showTime = _a.showTime, rangeType = _a.rangeType, monthOnly = _a.monthOnly, hovered = _a.hovered, props = tslib_1.__rest(_a, ["value", "onChange", "type", "onTypeChange", "curViewMoment", "onCurViewMomentChange", "range", "disabledDate", "disabledMonth", "disabledTime", "showTime", "rangeType", "monthOnly", "hovered"]);
    var t = i18n_1.useTranslation();
    var rangePickerRange = react_1.useContext(RangePickerContext_1.RangePickerContext).range;
    // 记录 Table 切换
    var prevTypeRef = react_1.useRef(null);
    var prevType = prevTypeRef.current;
    if (type === "month" || type === "date") {
        prevTypeRef.current = type;
    }
    var tableProps = tslib_1.__assign(tslib_1.__assign({}, props), { range: range,
        onTypeChange: onTypeChange, current: curViewMoment, onCurrentChange: onCurViewMomentChange });
    var timeProps = typeof showTime === "object" ? showTime : {};
    function getValue() {
        if (!Array.isArray(value)) {
            return value;
        }
        if (rangeType === "start") {
            return value[0];
        }
        return value[1];
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FadeTransition_1.FadeTransition, { in: type === "year", exit: false },
            react_1.default.createElement(YearTable_1.YearTable, tslib_1.__assign({}, tableProps, { onSelect: function (value) {
                    onCurViewMomentChange(moment_1.default(curViewMoment).year(value.year()));
                    onTypeChange(prevType || (monthOnly ? "date" : "month"));
                }, cellStatus: function (date) {
                    if (!Array.isArray(value)) {
                        if (moment_1.default.isMoment(value) && util_1.isSame(date, value, "year")) {
                            return BaseTable_1.CellStatus.Selected;
                        }
                    }
                    return BaseTable_1.CellStatus.Common;
                } }))),
        react_1.default.createElement(FadeTransition_1.FadeTransition, { in: type === "month", exit: false },
            react_1.default.createElement(MonthTable_1.MonthTable, tslib_1.__assign({}, tableProps, { onSelect: function (value, context) {
                    onCurViewMomentChange(moment_1.default(curViewMoment).month(value.month()));
                    if (monthOnly) {
                        onChange(value, context);
                        return;
                    }
                    onTypeChange("date");
                }, cellStatus: function (date) {
                    if (!Array.isArray(value)) {
                        if (moment_1.default.isMoment(value) && util_1.isSame(date, value, "month")) {
                            return BaseTable_1.CellStatus.Selected;
                        }
                    }
                    return BaseTable_1.CellStatus.Common;
                }, disabledMonth: disabledMonth }))),
        react_1.default.createElement(FadeTransition_1.FadeTransition, { in: type === "date", exit: false },
            react_1.default.createElement(DateTable_1.DateTable, tslib_1.__assign({}, tableProps, { value: getValue(), disabledDate: function (date) {
                    // 范围选择已选择 start，未选择 end
                    if (Array.isArray(value) &&
                        moment_1.default.isMoment(value[0]) &&
                        !moment_1.default.isMoment(value[1])) {
                        return disabledDate(date, value[0]);
                    }
                    return disabledDate(date);
                }, onSelect: function (v, context) {
                    // 单日选择
                    context.type = "date";
                    if (!Array.isArray(value)) {
                        return onChange(v, context);
                    }
                    // 范围选择
                    if (moment_1.default.isMoment(value[0]) && !moment_1.default.isMoment(value[1])) {
                        if (util_1.isBefore(value[0], v)) {
                            return onChange([value[0], v], context);
                        }
                        return onChange([v, value[0]], context);
                    }
                    return onChange([v, null], context);
                }, cellStatus: function (date) {
                    // 单日选择
                    if (!Array.isArray(value)) {
                        if (moment_1.default.isMoment(value) && util_1.isSame(date, value, "day")) {
                            return BaseTable_1.CellStatus.Selected;
                        }
                        return BaseTable_1.CellStatus.Common;
                    }
                    // 范围选择
                    if (moment_1.default.isMoment(value[0]) && util_1.isSame(date, value[0], "day")) {
                        // 只选中了开始或开始结束在同一天返回 Selected
                        if (!moment_1.default.isMoment(value[1])) {
                            return BaseTable_1.CellStatus.Selected;
                        }
                        if (util_1.isSame(value[0], value[1], "day")) {
                            return BaseTable_1.CellStatus.Selected;
                        }
                        return BaseTable_1.CellStatus.RangeStart;
                    }
                    if (moment_1.default.isMoment(value[1]) && util_1.isSame(date, value[1], "day")) {
                        return BaseTable_1.CellStatus.RangeEnd;
                    }
                    if (moment_1.default.isMoment(value[0]) && moment_1.default.isMoment(value[1])) {
                        if (util_1.isBefore(value[0], date) && util_1.isAfter(value[1], date)) {
                            return BaseTable_1.CellStatus.InRange;
                        }
                    }
                    if (moment_1.default.isMoment(value[0]) &&
                        !moment_1.default.isMoment(value[1]) &&
                        moment_1.default.isMoment(hovered)) {
                        if (util_1.isBefore(value[0], date) && util_1.isAfter(hovered, date)) {
                            return BaseTable_1.CellStatus.InRangeHover;
                        }
                        if (util_1.isBefore(hovered, date) && util_1.isAfter(value[0], date)) {
                            return BaseTable_1.CellStatus.InRangeHover;
                        }
                    }
                    return BaseTable_1.CellStatus.Common;
                } }))),
        react_1.default.createElement(FadeTransition_1.FadeTransition, { in: type === "time", exit: false },
            react_1.default.createElement(TimeTable_1.TimeTable, tslib_1.__assign({ caption: moment_1.default.isMoment(getValue()) ? getValue().format("L") : t.selectTime, value: getValue(), onChange: function (v, context) {
                    context.type = "time";
                    // 日期选择完才可选择时间，所以 value 必定合法
                    if (!Array.isArray(value)) {
                        return onChange(v, context);
                    }
                    if (rangeType === "start") {
                        return onChange([v, value[1]], context);
                    }
                    return onChange([value[0], v], context);
                }, range: getTimeRange(getValue(), rangePickerRange || range) }, (disabledTime(value, rangeType) || {}), timeProps)))));
}
exports.CalendarTable = CalendarTable;
CalendarTable.displayName = "CalendarTable";
//# sourceMappingURL=CalendarTable.js.map